  <div fxLayout="row" fxFlex="100" fxLayoutAlign="left">
  
      <giorno *ngFor="let giorno of giorni" [valore]="giorno"></giorno>
  </div>
